// commonStyles.js
import styled from 'styled-components';


export const H1 = styled.h1`
font-family: "Roboto", sans-serif; 
  font-size: 32px;
  font-weight: SemiBold;
  color: #000;
  line-height:110%;
`;

export const H2 = styled.h2`
font-family: "Roboto", sans-serif; 
  font-size: 24px;
  font-weight: SemiBold;
  color: #000;
  line-height:110%;
`;


export const H3 = styled.h3`
font-family: "Roboto", sans-serif; 
  font-size: 18px;
  font-weight: SemiBold;
  color: #000;
  line-height:120%;
`;

export const Body1 = styled.p`
font-family: "Roboto", sans-serif; 
  font-size: 16px;
  font-weight: Regular;
  color: #000;
  line-height:150%;
`;


export const Body2 = styled.p`
font-family: "Roboto", sans-serif; 
  font-size: 16px;
  font-weight: Bold;
  color: #000;
  line-height:150%;
`;

export const Body3 = styled.p`
font-family: "Roboto", sans-serif; 
  font-size:14px;
  font-weight: Regular;
  color: #000;
  line-height:140%;
`;

export const Body4 = styled.p`
font-family: "Roboto", sans-serif; 
  font-size:14px;
  font-weight: Regular;
  color: #000;
  line-height:120%;
`;

export const Body5 = styled.p`
font-family: "Roboto", sans-serif; 
  font-size:12px;
  font-weight: Regular;
  color: #000;
  line-height:120%;
`;


export const Container = styled.div`
    display: flex;
    padding: 10px;
    justify-content: space-between;

      @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        overflow:hidden;
        height:100%;
  }
`;
